@if (imgList.length == 0 && multiple) {
  <h3>{{'Upload a maximum of' | translate}} {{quantity}} {{'images at a time' | translate}}</h3>
}
<label class="input-upload" appDragNdrop
  (filesChangeEmiter)="onDropHandler($event)"
  (filesInvalidEmiter)="onInvalidDropHandler($event)"
  [allowed_extensions]="allowed_extensions"
  [multiple]="multiple"
  [ngClass]="{'mt-0-5': imgList.length > 0 && multiple}"
  [ngStyle]="{'height': height}">
  {{'Drag and drop image here or press to select from folder' | translate}}
  <span>.png .jpg</span>
  <input type="file" (change)="onChangeHandler($event)" [multiple]="multiple" accept="{{accepted}}">
</label>

@if (imgList.length > quantity) {
  <div class="Alert Notification">{{'Upload a maximum of' | translate}} {{quantity}} {{'images at a time' | translate}}</div>
}
<div class="L-12 M-12 S-12 columns TextCentered">
  @if (!coverSelected()) {
    <div class="Alert">{{'Please select a cover image to continue' | translate}}</div>
  }
  @for (img of imgList; track img; let i = $index) {
    <div class="L-3 M-3 S-4 columns">
      <div class="imageConteiner" imageSize>
        <img [src]="img" alt="" imageLoader  (load)="Resize($event)">
        <a (click)="onDeleteFile($event, i)" class="deletebtn"></a>
      </div>
      @if (cover) {
        <div class="L-12 M-12 S-12 columns">
          <input type="checkbox" [(ngModel)]="covers[i]" name="{{'cover_'+ i}}" (ngModelChange)="checkCover(i)">
          <p class="checkbox"> {{'Cover image' | translate}}</p>
        </div>
      }
      @if (useCheckbox) {
        <div class="L-12 M-12 S-12 columns">
          <input type="checkbox" [(ngModel)]="checkboxes[i]" name="{{'checkboxes_'+ i}}">
          <p class="checkbox custom"> {{checkboxText}}</p>
        </div>
      }
    </div>
  }
  @if (!allowSendMultiple) {
    <div class="L-12 M-12 S-12 columns TextCentered">
      @if (imgList.length > 0 && imgList.length <= quantity && coverSelected()) {
        <a class="button" (click)="onSendFiles($event)">{{'Continue' | translate}}</a>
      }
    </div>
  }
</div>